import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface TimeInputUniDriver extends BaseUniDriver {
  getValue: () => Promise<Date>;
  setValue: (value: string) => Promise<void>;
  confirmValue: () => Promise<void>;
  getLocale: () => Promise<string>;
  getTimeStyle: () => Promise<string>;
  isDisabled: () => Promise<boolean>;
  hasStatus: () => Promise<boolean>;
  getStatusMessage: () => Promise<string | null>;
}
